import baker from './baker.png'
import brown from './brown.png'
import calpoly from './calpoly.png'
import caltech from './caltech.png'
import depauw from './depauw.png'
import duke from './duke.png'
import gatech from './gatech.png'
import iastate from './iastate.png'
import kent from './kent.png'
import lafayette from './lafayette.png'
import lindenwood from './lindenwood.png'
import mcgill from './mcgill.png'
import msu from './msu.png'
import ndscs from './ndscs.png'
import ndsul from './ndsu1.png'
import ndus from './ndus.png'
import northwestern from './northwestern.png'
import pima from './pima.png'
import regina from './regina.png'
import rice from './rice.png'
import rochester from './rochester.png'
import sou from './sou.png'
import stanford from './stanford.png'
import uark from './uark.png'
import ucb from './ucb.png'
import uconn from './uconn.jpg'
import uh from './uh.png'
import uic from './uic.png'
import und from './und.png'
import unf from './unf.png'
import unh from './unh.png'
import uop from './uop.png'
import usc from './usc.png'
import uscar from './uscar.png'
import uvic from './uvic.png'
import yale from './yale.png'

export default {
  yale,
  stanford,
  rice,
  gatech,
  usc,
  caltech,
  brown,
  mcgill,
  msu,
  uconn,
  ucb,
  unh,
  baker,
  calpoly,
  depauw,
  duke,

  iastate,
  kent,
  lafayette,
  lindenwood,
  ndscs,
  ndsul,
  ndus,
  northwestern,
  pima,
  regina,
  rochester,
  sou,
  uark,
  uh,
  uic,
  und,
  unf,
  uop,
  uscar,
  uvic
}



// WEBPACK FOOTER //
// ./src/assets/highered_logos/exports.js